import { Path } from '../../../utils/constants'

export const getReportShareableUrl = (id: string) =>
  `${window.location.protocol}//${window.location.host}${Path.REPORTS_PERSONALIZED}?id=${id}`
export const getBasketShareableUrl = (id: string) =>
  `${window.location.protocol}//${window.location.host}${Path.REPORTS_PERSONALIZED_BASKETS}?id=${id}`
